import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  PagingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableBandHeader,
  SearchPanel,
  Toolbar,
} from "@devexpress/dx-react-grid-bootstrap4";
import { PagingPanel } from "@devexpress/dx-react-grid-material-ui";
import "../../theme/styles/dx-react-grid-bootstrap4.css";
import "../../theme/styles/reactstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
var styles = require("./Report.less");
import { DropdownButton, MenuItem, Button } from "react-bootstrap";
import * as commonActions from "./../../actions/commonActions";
import * as reportActions from "./../../actions/reportActions";
import moment from "moment";
import "../../theme/styles/bootstraptable.css";
import * as instrumentListActions from "./../../actions/instrumentListActions";
import * as tradepanelActions from "./../../actions/tradepanelActions";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../theme/styles/mediaqueries.css";
import Modal from "react-modal";
import i18next from "i18next";
import { DcoDropdown } from "../../components/UI/Dropdown/Dropdown";
import ReactExport from "react-data-export";
import { applyStyle, applyToHover } from "./../../utils/utils";
import { withStyles } from "@material-ui/core/styles";
import DateSelector from "./../DateSelector/DateSelector";
import {
  setDirection,
  getSelectedDate,
  getCountofTableRows,
  getFormattedDate,
} from "./../../utils/utils"; //import
import config from "./../../config.js";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let defAccFlag = true;
const elementsData = [
  {
    classNames: "accfilterBar",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "statementOfAccountbl",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "fltrBarInner",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "reportsDropdown",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "caret",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "dropdown-menu",
    elementType: "normal",
    applyTo: "all",
    tagNames: "ul",
    parent: "dropdown",
  },
  {
    classNames: "dropDownList",
    elementType: "tag",
    applyTo: "all",
    tagNames: "a",
  },
  {
    classNames: "glyphicon",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "material-icons",
    elementType: "normal",
    applyTo: "all",
    tagNames: "i",
  },
  {
    classNames: "reportsTblGrid",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "form-control",
    elementType: "normal",
    applyTo: "all",
    tagNames: "input",
  },
  {
    classNames: "oi-eye",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "mdlWrap",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "dropdown-toggle",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "noDataCell",
    elementType: "tag",
    applyTo: "all",
    tagNames: "td",
  },
  {
    classNames: "closeBtn",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
];
const directionData = [
  {
    classNames: "statementOfAccountbl",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "fltrBarInner",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "exportfileBaracc",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "accfilterItem",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "SOAaccountList",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "labelcolumn1",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "wrapper1",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "accfilterItemcol1",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "SOAdatePart",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "thirdPartcol1",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "labelcolumn2",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "thirdPart",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "btnText",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "dropdown-menu",
    elementType: "normal",
    applyTo: "all",
    tagNames: "ul",
  },
  {
    classNames: "filterSoaopt",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
];
@connect(
  (state) => ({
    statement_AccountData:
      state.dashboardRoot.reportReducer.statement_AccountData,
    socketDataStatic:
      state.dashboardRoot.instrumentListReducer.socketDataStatic,
    trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
    unitData: state.dashboardRoot.instrumentListReducer.unitData,
    currencyData: state.dashboardRoot.instrumentListReducer.currencyData,
    localCurrency: state.dashboardRoot.instrumentListReducer.localCurrency,
    defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    DCO: state.dashboardRoot.instrumentListReducer.DCO,
    selectedCssColorTheme:
      state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    dropdown: state.dashboardRoot.instrumentListReducer.dropdown,
    yearList: state.auth.userDetail.yearList,
  }),
  {
    ...reportActions,
    ...instrumentListActions,
    ...tradepanelActions,
    ...commonActions,
  }
)
export default class ReportComponent extends Component {
  static propTypes = {
    loadstatementOfaccountReport: PropTypes.func.isRequired,
    statement_AccountData: PropTypes.object,
    getExportedReport: PropTypes.func,
    socketDataStatic: PropTypes.array,
    unitData: PropTypes.object,
    trdPanelData: PropTypes.object,
    currencyData: PropTypes.object,
    localCurrency: PropTypes.object,
    generateSOAPdf: PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    DCO: PropTypes.object,
    dropdown: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      type: "",
      statement_AccountData: this.props.statement_AccountData,
      acc_DateOpt: "",
      acc_Codeopt: this.props.DFA.D,
      accCode: this.props.DFA.C,
      col1values: [],
      col2values: [],
      col1Defvalues: [],
      col2Defvalues: [],
      column1: "",
      column2: "",
      headercol1: "",
      headercol2: "None",
      headerunit1: "",
      headerunit2: "",
      loaderflag: false,
      qty: [],
      qty2: [],
      currency: [],
      currency2: [],
      notechecked: 1,
      showRptDialog: false,
      loadtableflag: true,
      isClearSOAreport: false,
      isRefreshDisabled: true,
      currentDate: new Date().toLocaleDateString("en-US"),
      startDate: getFormattedDate(new Date()),
      endDate: getFormattedDate(new Date()),
      ranges: {
        [i18next.t("today")]: [moment(), moment()],
        [i18next.t("yesterday")]: [
          moment().subtract(1, "days"),
          moment().subtract(1, "days"),
        ],
        [i18next.t("last7Days")]: [moment().subtract(6, "days"), moment()],
        [i18next.t("last30Days")]: [moment().subtract(29, "days"), moment()],
        [i18next.t("thisMonth")]: [
          moment().startOf("month"),
          moment().endOf("month"),
        ],
        [i18next.t("lastMonth")]: [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
      pageSizes: [10, 15, 20, 0],
      searchValue: "",
      accountList: Array.from(this.props.ACD.values()),
      id: "today",
      keyValue: "statementOfAccount",
      validationFlag: false,
      reportsRowsCount: 0,
      SOAtableColumns1: [
        "docno",
        "docdate",
        "valdate",
        "Narration",
        "Col1_debit",
        "Col1_credit",
        "Col1_RunBal",
      ],
      SOAtableColumns2: [
        "docno",
        "docdate",
        "valdate",
        "Narration",
        "Col1_debit",
        "Col1_credit",
        "Col1_RunBal",
        "Col2_debit",
        "Col2_credit",
        "Col2_RunBal",
      ],
      yearListHeading: "",
    };
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    const hoverElementsClassNames = [
      {
        elmToHover: thisComponent.getElementsByClassName("closeBtn")[0],
        classNames: "closeBtn",
      },
      {
        elmToHover: thisComponent.getElementsByClassName("button-l")[0],
        classNames: "button-l",
      },
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    setDirection(
      ReactDOM.findDOMNode(this),
      directionData,
      this.props.selectedLang
    );
    this.setState({ notechecked: true });
    this.setState({ notechecked: 1 });
    this.noteCheckboxChange = this.noteCheckboxChange.bind(this);
    window.handlestatementReport = this.handlestatementReport.bind(this);
    const length = this.props.socketDataStatic.length;

    // let obj2 = {
    //   cmdtDesc: "None",
    //   cmdtId: 'None'
    // };
    // tempCol2.push(obj2);
    // defaultCol2.push(obj2);
    // let obj3 = {
    //   cmdtDesc: "localCurrency",
    //   cmdtId: 'LC'
    // };
    // tempCol1.push(obj3);
    // defaultCol2.push(obj3);
    // let obj4 = {
    //   cmdtDesc: "foreignCurr",
    //   cmdtId: 'FC'
    // };
    // tempCol1.push(obj4);
    // tempCol2.push(obj4);
    // defaultCol2.push(obj4);

    // for (let index = 0; index < length; index++) {
    //   if (this.props.socketDataStatic[index].I !== -1 ) {
    //   let cmdtyDes;
    //   let cmdtyId;
    //   let obj={};
    //   let flag1;
    //   let flag2;
    //     if (this.props.socketDataStatic[index].TT1=="M") {
    //       cmdtyDes = this.props.socketDataStatic[index].D1;
    //       cmdtyId = this.props.socketDataStatic[index].T1;
    //       for (let index1 = 0; index1 < tempCol1.length; index1++) {
    //         if(cmdtyDes === tempCol1[index1].cmdtDesc){
    //           flag1= 0;
    //           break;
    //         }else{
    //           flag1= 1;
    //         }
    //       }
    //       cmdty_metal.push(this.props.socketDataStatic[index].D1);
    //     }
    //
    //     if (flag1 === 1) {
    //        obj = {
    //         cmdtDesc: cmdtyDes,
    //         cmdtId:this.props.socketDataStatic[index].T1,
    //       }
    //         tempCol1.push(obj);
    //         tempCol2.push(obj);
    //         defaultCol2.push(obj);
    //     }
    //
    //      if(this.props.socketDataStatic[index].TT2=="M") {
    //       cmdtyDes = this.props.socketDataStatic[index].D2;
    //       cmdtyId = this.props.socketDataStatic[index].T2;
    //       for (let index1 = 0; index1 < tempCol1.length; index1++) {
    //         if(cmdtyDes === tempCol1[index1].cmdtDesc){
    //           flag2= 0;
    //           break;
    //         }else{
    //           flag2= 1;
    //         }
    //       }
    //     }
    //
    //     if (flag2 === 1) {
    //        obj = {
    //         cmdtDesc: cmdtyDes,
    //         cmdtId:this.props.socketDataStatic[index].T2,
    //         }
    //       tempCol1.push(obj);
    //       tempCol2.push(obj);
    //       defaultCol2.push(obj);
    //     }
    //
    //   }
    // }
    // console.log("this.props.dropdown " + JSON.stringify(this.props.dropdown));

    let cmdty_metal = [...this.props.dropdown.cmdty_metal];
    let LcObj = { cmdtDesc: "Local Currency", cmdtId: "LC" };
    let FcObj = { cmdtDesc: "Foreign Currency", cmdtId: "FC" };
    let NoneObj = { cmdtDesc: "None", cmdtId: "None" };
    let tempCol1 = [...this.props.dropdown];
    tempCol1.unshift(FcObj);
    tempCol1.unshift(LcObj);
    // console.log("tempCol1 "+ JSON.stringify(tempCol1));
    let tempCol2 = [...this.props.dropdown];
    tempCol2.unshift(FcObj);
    tempCol2.unshift(NoneObj);

    let defaultCol2 = [...this.props.dropdown];
    defaultCol2.unshift(FcObj);
    defaultCol2.unshift(LcObj);
    defaultCol2.unshift(NoneObj);

    let COM;
    if (cmdty_metal.indexOf(tempCol1[0].cmdtDesc) === -1) {
      COM = 1;
    }
    // if(tempCol1[0].cmdtDesc==="Local Currency"){
    //   COM="";
    // }
    this.setState({
      COM: COM,
      yearListHeading: this.props.yearList[0].YEAR,
      col1values: tempCol1,
      col2values: tempCol2,
      col1Defvalues: tempCol1,
      col2Defvalues: defaultCol2,
      type: "docDate",
      acc_DateOpt: "Doc Date",
      col2: tempCol2[0].cmdtDesc,
      column2: tempCol2[0].cmdtDesc,
      unit_code2: "",
      col1: tempCol1[0].cmdtId,
      column1: tempCol1[0].cmdtDesc,
      unit_code1: "",
      headercol1: tempCol1[0].cmdtDesc,
      headercol2: "None",
      accCode: this.props.DFA.C,
      acc_Codeopt: this.props.DFA.D,
      cmdty_metal: cmdty_metal,
    },
      () => {
        this.onClickFilter();
      })
}

changeFlag = () => {
  try{
    this.setState({showRptDialog: true});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"StatementOfAccount"});
  }
}
closeRptModal = (event) => {
  try{
    this.setState({showRptDialog: false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"StatementOfAccount"});
  }
}
handlestatementReport = () => {
  try {
    this.setState({ loadtableflag: true, isRefreshDisabled: true, loaderflag: true },
      () => {
        this.onClickFilter();
      })
  } catch (e) {
    this.props.logFileCreation({ error: e.message, originFunction: 'handlestatementReport', component: "StatementOfAccount" });
  }
}

  componentWillMount() {
    const locale = locale;
    this.setState({
      locale: {
        format: "DD-MM-YYYY",
        applyLabel: i18next.t("apply"),
        cancelLabel: i18next.t("cancel"),
        customRangeLabel: i18next.t("customRange"),
        daysOfWeek: [
          i18next.t("su"),
          i18next.t("mo"),
          i18next.t("tu"),
          i18next.t("we"),
          i18next.t("th"),
          i18next.t("fr"),
          i18next.t("sa"),
        ],
        monthNames: [
          i18next.t("jan"),
          i18next.t("feb"),
          i18next.t("mar"),
          i18next.t("apr"),
          i18next.t("may"),
          i18next.t("jun"),
          i18next.t("jul"),
          i18next.t("aug"),
          i18next.t("sep"),
          i18next.t("oct"),
          i18next.t("nov"),
          i18next.t("dec"),
        ],
      },
    });
  }
  componentWillReceiveProps(nextProps) {
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //       {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
    //       {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    //   setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    // }

    if (this.state.isClearSOAreport !== this.props.isClearSOAreport) {
      this.setState({ isClearSOAreport: true });
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled: true });
      this.setState({ accCode: this.props.DFA.C });
      this.setState({ acc_Codeopt: this.props.DFA.D });
      this.setState({ acc_DateOpt: "Doc Date" });
      this.setState({ type: "docDate" });
      this.setState({ headercol1: this.state.col1values[0].cmdtDesc });
      this.setState({ headercol2: "None" });
      this.setState({ column1: i18next.t("localCurrency") });
      this.setState({ col1: "LC" });
      this.setState({ unit_code1: "" });
      this.setState({ column2: i18next.t("None") });
      this.setState({ col2: "None" });
      this.setState({ unit_code2: "" });
      this.setState({ id: "today" });
      this.setState({ startDate: new Date().toLocaleDateString("en-US") });
      this.setState({ endDate: new Date().toLocaleDateString("en-US") });
      this.setState({ currentDate: new Date().toLocaleDateString("en-US") });
    }
    if (nextProps.statement_AccountData !== this.props.statement_AccountData) {
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled: false });
      let statement_Acc = [];
      statement_Acc = nextProps.statement_AccountData;
      for (let i = 0; i < statement_Acc.length; i++) {
        if (statement_Acc[i].Col1_credit) {
          if (parseFloat(statement_Acc[i].Col1_credit) === 0) {
            statement_Acc[i].Col1_credit = "";
          }
        }
        if (statement_Acc[i].Col1_debit) {
          if (parseFloat(statement_Acc[i].Col1_debit) === 0) {
            statement_Acc[i].Col1_debit = "";
          }
        }
        if (statement_Acc[i].Col2_credit) {
          if (parseFloat(statement_Acc[i].Col2_credit) === 0) {
            statement_Acc[i].Col2_credit = "";
          }
        }
        if (statement_Acc[i].Col2_debit) {
          if (parseFloat(statement_Acc[i].Col2_debit) === 0) {
            statement_Acc[i].Col2_debit = "";
          }
        }
      }
      this.setState({ statement_AccountData: statement_Acc });
      this.setState({ reportsRowsCount: statement_Acc.length });
    }
    if(nextProps.defAcc !== this.props.defAcc){
        this.setState({acc_Codeopt: nextProps.defAcc.AD});
        this.setState({accCode:nextProps.defAcc.AC})
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
 }
setStartDate = startDate => {
  try{
    this.setState({ startDate:startDate});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"StatementOfAccount"});
  }
}
 setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"StatementOfAccount"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"StatementOfAccount"});
    }
  }

  handleEvent = (event, picker) => {
    try{
      this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvent', component:"StatementOfAccount"});
    }
  }

  acc_DateOpt = (text, type) => {
    try {
      this.setState({ acc_DateOpt: text, type: type, loadtableflag: true },
        () => {
          this.onClickFilter();
        });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'acc_DateOpt', component: "StatementOfAccount" });
    }
  }

  onClickFilter = () => {
    this.setState({ loadtableflag : true });
    this.props.loadstatementOfaccountReport(
      this.state.accCode,
      this.state.type,
      moment(this.state.startDate).format("DD-MM-YYYY"),
      moment(this.state.endDate).format("DD-MM-YYYY"),
      this.state.col1,
      this.state.col2,
      this.state.unit_code1,
      this.state.unit_code2,
      this.state.notechecked,
      this.state.yearListHeading
    );
  };
  
  acc_Codeopt = (text, key) => {
    try {
      if (this.props.DFA.C !== key) {
        defAccFlag = false;
        this.setState({ AccFlag: false });
        //this.setState(defAccFlag:false);
      } else {
        defAccFlag = true;
        this.setState({ AccFlag: true });
      }
      this.setState({ acc_Codeopt: text, accCode: key, loadtableflag: true },
        () => {
          this.onClickFilter();
        })
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'acc_Codeopt', component:"StatementOfAccount"});
    }
  }

  onChangeCmdy_col1 = (key,text) => {
    try {
      var unit_code1 = "";
      let temp = [];
      this.state.col2Defvalues.map((item, index) => {
        if (item.cmdtId != key) {
          temp.push(item);
        }
      });
      this.setState({ col2values: temp });
      if (key === "All") {
        this.setState({ column2: "None" });
        this.setState({ col2: "None" });
      }
      if (key === "FC") {
        let lengthcurrencyData = this.props.currencyData.length;
        const currencyvalue = [];
        for (let index = 0; index < lengthcurrencyData; index++) {
          currencyvalue.push(this.props.currencyData[index].S);
        }
        this.setState({ currency: currencyvalue, unit_code1: currencyvalue[0] });
        unit_code1 = currencyvalue[0];
      }
      if (key !== "All" && key !== "LC" && key !== "FC") {
        let length = this.props.socketDataStatic.length;
        let index1;
        for (let index = 0; index < length; index++) {
          if (
            this.props.socketDataStatic[index].T1 == key ||
            this.props.socketDataStatic[index].T2 === key
          ) {
            index1 = index;
          }
        }
        const unit = [];
        const lengthunitData = this.props.unitData.length;
        for (let index = 0; index < lengthunitData; index++) {
          unit.push(this.props.unitData[index].U);
        }
        if (
          this.props.socketDataStatic[index1].C == 1 ||
          this.props.socketDataStatic[index1].C == 4 ||
          this.props.socketDataStatic[index1].C == 8 ||
          this.props.socketDataStatic[index1].C == 32
        ) {
          this.setState({ unit_code1: unit[0] });
          unit_code1 = unit[0];
        } else {
          this.setState({ unit_code1: "" });
          unit_code1 = "";
        }
        this.setState({ qty: unit });
      }
      let COM;
      if (this.state.cmdty_metal.indexOf(text) === -1) {
        COM = 1;
      }
      this.setState(
        {
          loadtableflag: true,
          column1: text,
          col1: key,
          COM: COM,
          headercol1: text,
          headerunit1: unit_code1,
        },
        () => {
          this.onClickFilter();
        }
      );
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onChangeCmdy_col1', component: "StatementOfAccount" });
    }
  }

  onChangeCmdy_col2 = (key, text) => {
    try {
      var unit_code2 = "";
      let temp = [];
      this.state.col1Defvalues.map((item, index) => {
        if (item.cmdtId != key) {
          temp.push(item);
        }
      });
      if (key === "FC") {
        let lengthcurrencyData = this.props.currencyData.length;
        const currencyvalue = [];
        for (let index = 0; index < lengthcurrencyData; index++) {
          currencyvalue.push(this.props.currencyData[index].S);
        }
        this.setState({ currency2: currencyvalue });
        this.setState({ unit_code2: currencyvalue[0] });
        unit_code2 = currencyvalue[0];
      }

      if (key === "LC") {
        this.setState({ unit_code2: "" });
        unit_code2 = "";
      }
      if (key === "None") {
        this.setState({ unit_code2: "" });
        unit_code2 = "";
      }

      if (key !== "None" && key !== "LC" && key !== "FC") {
        let length = this.props.socketDataStatic.length;
        let index1;
        for (let index = 0; index < length; index++) {
          if (
            this.props.socketDataStatic[index].T1 === key ||
            this.props.socketDataStatic[index].T2 === key
          ) {
            index1 = index;
          }
        }
        const unit2 = [];
        const lengthunitData = this.props.unitData.length;
        for (let index = 0; index < lengthunitData; index++) {
          unit2.push(this.props.unitData[index].U);
        }
        if (
          this.props.socketDataStatic[index1].C == 1 ||
          this.props.socketDataStatic[index1].C == 4 ||
          this.props.socketDataStatic[index1].C == 8 ||
          this.props.socketDataStatic[index1].C == 32
        ) {
          this.setState({ unit_code2: unit2[0] });
          unit_code2 = unit2[0];
        } else {
          this.setState({ unit_code2: "" });
          unit_code2 = "";
        }
        this.setState({ qty2: unit2 });
      }
      let COM;
      if (this.state.cmdty_metal.indexOf(text) === -1) {
        COM = 1;
      }

      this.setState({
        loadtableflag: true,
        column2: text,
        col2: key,
        col1values: temp,
        COM: COM,
        headercol2: text,
        headerunit2: unit_code2,
      }, () => {
        this.onClickFilter();
      })
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onChangeCmdy_col2', component: "StatementOfAccount" });
    }
  }

  qty = (text) => {
    try{
      this.setState(
        { unit_code1: text, headerunit1: text, loadtableflag: true },
        () => {
          this.onClickFilter();
        }
      )
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'qty', component:"StatementOfAccount"});
    }
  }

  qty2 = (text) => {
    try{
      this.setState(
        { unit_code2: text, headerunit2: text, loadtableflag: true },
        () => {
          this.onClickFilter();
        }
      );
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'qty2', component:"StatementOfAccount"});
    }
  }

  currency = (text) => {
    try{
      this.setState(
        { unit_code1: text, headerunit1: text, loadtableflag: true },
        () => {
          this.onClickFilter();
        }
      );
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'currency', component:"StatementOfAccount"});
    }
  }

  currency2 = (text) => {
    try{
      this.setState(
        { unit_code2: text, headerunit2: text, loadtableflag: true },
        () => {
          this.onClickFilter();
        }
      );
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'currency2', component:"StatementOfAccount"});
    }
  }

  noteCheckboxChange = (event) => {
    try {
      this.setState({ loadtableflag: true });
      const isCheck = event.target.checked;
      if (isCheck === true) {
        this.setState({ notechecked: 1 }, () => {
          this.onClickFilter();
        });
      } else {
        this.setState({ notechecked: 0 }, () => {
          this.onClickFilter();
        });
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'noteCheckboxChange', component: "StatementOfAccount" });
    }
}

  generatePdf=(format)=>{
    try {
      const option = this.state.notechecked;
      if (this.props.statement_AccountData.length === 0 || this.props.reportData === '' || this.props.reportData === null) {
        this.setState({ showRptDialog: true });
      } else {
        this.props.generateSOAPdf(
          this.state.accCode,
          this.state.type,
          moment(this.state.startDate).format("DD-MM-YYYY"),
          moment(this.state.endDate).format("DD-MM-YYYY"),
          this.state.col1,
          this.state.col2,
          this.state.unit_code1,
          this.state.unit_code2,
          format,
          option, this.state.yearListHeading
        );
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'generatePdf', component: "StatementOfAccount" });
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      if(this.state.headercol2 && this.state.headercol2 ==='None'){
        var count=getCountofTableRows(this.state.statement_AccountData,this.state.SOAtableColumns1,value);
      }else{
        var count=getCountofTableRows(this.state.statement_AccountData,this.state.SOAtableColumns2,value);
      }
      this.setState({reportsRowsCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"StatementOfAccount"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"StatementOfAccount"});
    }
  }

  setYearHeading = (yearListHeading) => {
    try{
      this.setState({ yearListHeading });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setYearHeading', component:"StatementOfAccount"});
    }
  };

  render() {
    // console.log("col1values " + JSON.stringify(this.state.col1values));
    const {
      acc_DateOpt,
      acc_Codeopt,
      column1,
      column2,
      unit_code1,
      unit_code2,
      //show_note,
      currency,
      currency2,
      qty,
      qty2,
      headercol1,
      headercol2,
      headerunit1,
      headerunit2,
      option,
      DateOpt,
      cmdty_metal,
      cmdty_currency,
    } = this.state;
    const {
      accCode,
      type,
      startDate,
      endDate,
      col1values,
      col2values,
      col1Defvalues,
      col2Defvalues,
      col1,
      col2,
      basecurrency,
      sizePerPage,
      cmdtyId,
    } = this.state;
    const start = this.state.startDate;
    const end = this.state.endDate;
    let label = start + " - " + end;
    if (start === end) {
      label = start;
    }
    const pagingPanelMessages = {
      showAll: i18next.t("all"),
      rowsPerPage: i18next.t("rowsPerPage"),
      info: "",
    };
    const searchPlaceholderMsg = {
      searchPlaceholder: i18next.t("search") + "...",
    };

    const baseCurrency = this.props.localCurrency[0].basecurrency;
    let headerTitle = "";
    if (headercol1 && headercol1 === "Local Currency") {
      headerTitle =
        this.props.language == "AR"
          ? "(" + baseCurrency + ") " + i18next.t("amount")
          : i18next.t("amount") + " (" + baseCurrency + ")";
    }
    if (headercol1 && headercol1 === "Foreign Currency") {
      headerTitle =
        this.props.language == "AR"
          ? "(" + headerunit1 + ") " + i18next.t("amount")
          : i18next.t("amount") + " (" + headerunit1 + ")";
    }
    if (headercol1 && cmdty_metal.indexOf(headercol1) !== -1) {
      headerTitle =
        this.props.language == "AR"
          ? "(" + headerunit1 + ") " + headercol1
          : headercol1 + " (" + headerunit1 + ")";
    }
    if (
      this.state.COM == 1 &&
      !(
        (headercol1 && headercol1 === "Local Currency") ||
        (headercol1 && headercol1 === "Foreign Currency") ||
        (headercol1 && cmdty_metal.indexOf(headercol1) !== -1)
      )
    ) {
      headerTitle = headercol1;
    }
    // console.log("COM " + this.state.COM);
    const statement_AccountDatacols1 = [
      { name: "docno", title: i18next.t("docNo") },
      { name: "docdate", title: i18next.t("docDate") },
      { name: "valdate", title: i18next.t("valueDate") },
      { name: "Narration", title: i18next.t("narration") },
      { name: "Col1_debit", title: i18next.t("debit") },
      { name: "Col1_credit", title: i18next.t("credit") },
      { name: "Col1_RunBal", title: i18next.t("balance") },
    ];
    const columnBands1 = [
      {
        title: headerTitle,
        children: [
          { columnName: "Col1_debit" },
          { columnName: "Col1_credit" },
          { columnName: "Col1_RunBal" },
        ],
      },
    ];
    let headercol1Title = "";
    let headercol2Title = "";

    if (headercol2 && headercol2 !== "None") {
      if (headercol1 && headercol1 === "Local Currency") {
        headercol1Title =
          this.props.language == "AR"
            ? "(" + baseCurrency + ") " + i18next.t("amount")
            : i18next.t("amount") + " (" + baseCurrency + ")";
      }
      if (headercol1 && headercol1 === "Foreign Currency") {
        headercol1Title =
          this.props.language == "AR"
            ? "(" + headerunit1 + ") " + i18next.t("amount")
            : i18next.t("amount") + " (" + headerunit1 + ")";
      }
      if (headercol1 && cmdty_metal.indexOf(headercol1) !== -1) {
        headercol1Title =
          this.props.language == "AR"
            ? "(" + headerunit1 + ") " + headercol1
            : headercol1 + " (" + headerunit1 + ")";
      }
      if (
        this.state.COM == 1 &&
        !(
          (headercol1 && headercol1 === "Foreign Currency") ||
          (headercol1 && headercol1 === "Local Currency") ||
          (headercol2 && headercol2 === "None") ||
          (headercol1 && cmdty_metal.indexOf(headercol1) !== -1)
        )
      ) {
        headercol1Title = headercol1;
      }
      if (headercol2 && headercol2 === "Local Currency") {
        headercol2Title =
          this.props.language == "AR"
            ? "(" + baseCurrency + ") " + i18next.t("amount")
            : i18next.t("amount") + " (" + baseCurrency + ")";
      }
      if (headercol2 && headercol2 === "Foreign Currency") {
        headercol2Title =
          this.props.language == "AR"
            ? "(" + headerunit2 + ") " + i18next.t("amount")
            : i18next.t("amount") + " (" + headerunit2 + ")";
      }
      if (headercol2 && cmdty_metal.indexOf(headercol2) !== -1) {
        headercol2Title =
          this.props.language == "AR"
            ? "(" + headerunit2 + ") " + headercol2
            : headercol2 + " (" + headerunit2 + ")";
      }
      if (
        this.state.COM == 1 &&
        !(
          (headercol2 && headercol2 === "Local Currency") ||
          (headercol2 && headercol2 === "Foreign Currency") ||
          (headercol2 && headercol2 === "None") ||
          (headercol2 && cmdty_metal.indexOf(headercol2) !== -1)
        )
      ) {
        headercol2Title = headercol2;
      }
    }
    const statement_AccountDatacols2 = [
      { name: "docno", title: i18next.t("docNo") },
      { name: "docdate", title: i18next.t("docDate") },
      { name: "valdate", title: i18next.t("valueDate") },
      { name: "Narration", title: i18next.t("narration") },
      { name: "Col1_debit", title: i18next.t("debit") },
      { name: "Col1_credit", title: i18next.t("credit") },
      { name: "Col1_RunBal", title: i18next.t("balance") },
      { name: "Col2_debit", title: i18next.t("debit") },
      { name: "Col2_credit", title: i18next.t("credit") },
      { name: "Col2_RunBal", title: i18next.t("balance") },
    ];
    const columnBands2 = [
      {
        title: headercol1Title,
        children: [
          { columnName: "Col1_debit" },
          { columnName: "Col1_credit" },
          { columnName: "Col1_RunBal" },
        ],
      },
      {
        title: headercol2Title,
        children: [
          { columnName: "Col2_debit" },
          { columnName: "Col2_credit" },
          { columnName: "Col2_RunBal" },
        ],
      },
    ];
    var tableData = [];
    var tableData2 = [];
    var propData = this.props.statement_AccountData;
    for (let i = 0; i < propData.length; i++) {
      tableData[i] = [
        {
          value: propData[i].docno,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].docdate,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].valdate,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].Narration,
          style: { alignment: { horizontal: "left" } },
        },
        {
          value: propData[i].Col1_credit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col1_debit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col1_RunBal,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
      ];
      tableData2[i] = [
        {
          value: propData[i].docno,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].docdate,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].valdate,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].Narration,
          style: { alignment: { horizontal: "left" } },
        },
        {
          value: propData[i].Col1_credit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col1_debit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col1_RunBal,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
        {
          value: propData[i].Col2_credit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col2_debit,
          style: {
            alignment: { wrapText: true, horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          value: propData[i].Col2_RunBal,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
      ];
    }
    const columnCss1 = {
      border: {
        top: { style: "thin", color: { rgb: "00FFFFFF" } },
        bottom: { style: "thin", color: { rgb: "00FFFFFF" } },
      },
    };
    const columnCss2 = {
      border: {
        top: { style: "thin", color: { rgb: "00FFFFFF" } },
        right: { style: "thin", color: { rgb: "00FFFFFF" } },
      },
    };
    const columnCss3 = {
      border: { top: { style: "thin", color: { rgb: "00FFFFFF" } } },
    };
    const dataCss1 = { value: "", style: columnCss1 };
    const dataCss2 = { value: "", style: columnCss2 };
    const dataCss3 = { value: "", style: columnCss3 };
    const multiDataSet = [
      {
        columns: [
          { title: i18next.t("docNo"), width: { wpx: 150 } },
          { title: i18next.t("docDate"), width: { wpx: 100 } },
          { title: i18next.t("valueDate"), width: { wpx: 100 } },
          { title: i18next.t("narration"), width: { wpx: 350 } },
          { title: "", width: { wpx: 130 } },
          { title: headerTitle, width: { wpx: 130 } },
          { title: "", width: { wpx: 150 } },
        ],
        data: [
          [
            dataCss1,
            dataCss1,
            dataCss1,
            dataCss1,
            dataCss2,
            dataCss2,
            dataCss3,
          ],
        ],
      },
      {
        columns: [
          "",
          "",
          "",
          "",
          i18next.t("credit"),
          i18next.t("debit"),
          i18next.t("balance"),
        ],
        data: tableData,
      },
    ];
    const multiDataSet2 = [
      {
        columns: [
          { title: i18next.t("docNo"), width: { wpx: 150 } },
          { title: i18next.t("docDate"), width: { wpx: 100 } },
          { title: i18next.t("valueDate"), width: { wpx: 100 } },
          { title: i18next.t("narration"), width: { wpx: 350 } },
          { title: "", width: { wpx: 130 } },
          { title: headercol1Title, width: { wpx: 130 } },
          { title: "", width: { wpx: 150 } },
          { title: "", width: { wpx: 130 } },
          { title: headercol2Title, width: { wpx: 130 } },
          { title: "", width: { wpx: 150 } },
        ],
        data: [
          [
            dataCss1,
            dataCss1,
            dataCss1,
            dataCss1,
            dataCss2,
            dataCss2,
            dataCss3,
            dataCss2,
            dataCss2,
            dataCss3,
          ],
        ],
      },
      {
        columns: [
          "",
          "",
          "",
          "",
          i18next.t("credit"),
          i18next.t("debit"),
          i18next.t("balance"),
          i18next.t("credit"),
          i18next.t("debit"),
          i18next.t("balance"),
        ],
        data: tableData2,
      },
    ];
    const TableCell = (props) => {
      const { column } = props;
      if (column.name === "docdate" || column.name === "valdate") {
        return <Table.Cell {...props} className="commonDateAR" />;
      }
      return <Table.Cell {...props} />;
    };
    const rowStyle = (theme) => ({
      tableStriped: {
        "& tbody tr:nth-of-type(odd)": {
          // backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        "& tbody tr:nth-of-type(even)": {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        "& thead tr": {
          //backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background
        },
        "& thead th": {
          //color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        "& .text-primary": {
          //color: this.props.selectedCssColorTheme.activeHeaderColor.color
        },
      },
    });
    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} className={classes.tableStriped} />
    );
    const PagingContainer = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark" />
    );
    var NoDataMsg = {
      noData: "",
    };
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = "";
    } else {
      NoDataMsg.noData = i18next.t("noDataAvlMsg");
    }
    const NoDataCell = (props) => (
      <Table.NoDataCell {...props} className="noDataCell" />
    );
    return (
      <div id="stmntRptMainDiv" className={`${this.props.language}`}>
        <Modal
          isOpen={this.state.validationFlag}
          id="stmtDateValModal"
          className={styles.warningModal}
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              Error
              <span
                onClick={this.closeValidationModal}
                className={`${styles.closeImg} closeIcon`}
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              <h4>{i18next.t("dateSelectorErrMsg")}</h4>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showRptDialog}
          id="stmntWrngModal"
          className={styles.warningModal}
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>
                {i18next.t("stmntOfAccnt")}
              </span>
              <span
                onClick={this.closeRptModal}
                className={`${styles.closeImg} closeIcon`}
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              {i18next.t("noDataAvlMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button
                className="button-l"
                bsStyle="primary"
                onClick={this.closeRptModal}
              >
                {i18next.t("OK")}
              </Button>
            </div>
          </div>
        </Modal>

        <div
          className={`${styles.accfilterBar} accfilterBar ${this.props.selectedCssColor}`}
        >
          <div className={`${styles.accfilterBarInner} fltrBarInner`}>
            <div className={styles.soaOptionsWrapper}>
              <div>
                <div
                  className={`${styles.wrapper1} SOAaccountList`}
                  id="firstwrapper"
                >
                  <DropdownButton
                    title={acc_Codeopt}
                    id="bg-nested-dropdown"
                    className={`${styles.SOAaccount} reportsDropdown btnText`}
                  >
                    {this.state.accountList.map((item) => {
                      return (
                        <MenuItem
                          onClick={() => this.acc_Codeopt(item.D, item.C)}
                          id="stAccListMenu"
                        >
                          {item.D}
                        </MenuItem>
                      );
                    })}
                  </DropdownButton>
                </div>

                <div
                  className={`${styles.wrapper3} thirdPartcol1`}
                  id="thirdwrapper"
                >
                  <div
                    className={`${styles.soaFilter} filterSoaopt`}
                    id="SOADatefilter"
                    style={this.props.selectedLang.filterSoaopt}
                  >
                    <DropdownButton
                      title={i18next.t(type)}
                      id="bg-nested-dropdown"
                      className="reportsDropdown btnText"
                    >
                      <MenuItem
                        onClick={() => this.acc_DateOpt("Doc Date", "docDate")}
                        id="stAccTrdDate"
                      >
                        {i18next.t("docDate")}
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          this.acc_DateOpt("Value Date", "valDate")
                        }
                        id="stAccValDate"
                      >
                        {i18next.t("valDate")}
                      </MenuItem>
                    </DropdownButton>
                  </div>
                </div>
                
                <DateSelector
                  keyValue={this.state.keyValue}
                  onClickFilter={this.onClickFilter}
                  setStartDate={this.setStartDate}
                  setYearHeading={this.setYearHeading}
                  setEndDate={this.setEndDate}
                  component="Report"
                />

                {col2 && col2 !== "None" ? (
                  <div
                    className={styles.notelabel}
                    style={this.props.selectedLang.notelabel}
                  >
                    <label className={styles.containerClass}>
                      <input
                        type="checkbox"
                        className={styles.column1_checkbox}
                        checked={this.state.notechecked}
                        onChange={this.noteCheckboxChange}
                      />
                      <span className={styles.checkmark}></span>
                    </label>
                    <label className={`${styles.column1_lbl} col1Label`}>
                      {i18next.t("showTransConsideringColMsg")}
                    </label>
                  </div>
                ) : null}

              </div>

              {/* "qtyfilter" classname  is for currency dropdown and qty dropdown */}
              <div className={styles.currencyOptions}>
                <div
                  className={`${styles.wrapper1} ${styles.filterRow2} wrapper1`}
                  id="firstwrapper"
                >
                  <div
                    className={`${styles.labelcolumn1} labelcolumn1`}
                    id="column1label"
                  >
                    <span>{i18next.t("col1")}:</span>
                  </div>
                  <DcoDropdown
                    parentDivClassname={`${styles.accfilterItemcol1} accfilterItemcol1`}
                    parentDivId="SOAcol1Dropdown"
                    dropdownTitle={i18next.t(column1)}
                    dropdownId="bg-nested-dropdown"
                    dropdownData={col1values}
                    dataItemClick={this.onChangeCmdy_col1}
                    dropdownClassname="reportsDropdown btnText"
                  />
                  {/*}<div className={styles.accfilterItemcol1} id="SOAcol1Dropdown">
                    <DropdownButton title={column1} id="bg-nested-dropdown">
                    {col1values.map((item) => {
                        return (
                        <MenuItem onClick={() => this.column1(item.cmdtDesc, item.cmdtyId)} id="stAccCol1Menu">{item.cmdtDesc}</MenuItem>
                        );
                    })
                    }
                    </DropdownButton>
                </div>
                */}
                </div>
                {col1 === "FC" ? (
                  <div
                    className={`${styles.wrapper2} secondpart`}
                    id="secondwrapper"
                  >
                    <div
                      className={`${styles.qtyfilter} SOAqtydropdown`}
                      id="qtyfiltercol1"
                    >
                      <DropdownButton
                        title={unit_code1}
                        id="bg-nested-dropdown"
                        className="reportsDropdown btnText"
                      >
                        {currency &&
                          currency.map((currencyval) => {
                            return (
                              <MenuItem
                                onClick={() => this.currency(currencyval)}
                                id="stAccCurrency"
                              >
                                {currencyval}
                              </MenuItem>
                            );
                          })}
                      </DropdownButton>
                    </div>
                  </div>
                ) : null}
                {column1 && cmdty_metal.indexOf(column1) !== -1 ? (
                  <div
                    className={`${styles.wrapper2} secondpart`}
                    id="secondwrapper"
                  >
                    <div
                      className={`${styles.qtyfilter} SOAqtydropdown`}
                      id="qtyfiltercol1"
                    >
                      <DropdownButton
                        title={unit_code1}
                        id="bg-nested-dropdown"
                        className="reportsDropdown btnText"
                      >
                        {qty &&
                          qty.map((unitMeasure) => {
                            return (
                              <MenuItem
                                onClick={() => this.qty(unitMeasure)}
                                id="stAccUnitMeasure"
                              >
                                {i18next.t(unitMeasure)}
                              </MenuItem>
                            );
                          })}
                      </DropdownButton>
                    </div>
                  </div>
                ) : null}

                <div
                  className={`${styles.labelcolumn2} labelcolumn2`}
                  id="column2label"
                >
                  <span>{i18next.t("col2")}:</span>
                </div>
                <div
                  className={`${styles.wrapper3} thirdPart`}
                  id="thirdwrapper"
                >
                  <DcoDropdown
                    parentDivClassname={`${styles.accfilterItemcol2}`}
                    parentDivId="SOAcol2Dropdown"
                    dropdownTitle={i18next.t(column2)}
                    dropdownId="bg-nested-dropdown"
                    dropdownData={col2values}
                    dataItemClick={this.onChangeCmdy_col2}
                    dropdownClassname="reportsDropdown btnText"
                  />
                  {/*<div className={styles.accfilterItemcol2} id="SOAcol2Dropdown" >
                    <DropdownButton title={column2} id="bg-nested-dropdown" disabled={this.state.col1 === 'All'}>
                        {col2values.map((item) => {
                        return (
                            <MenuItem onClick={() => this.column2(item.cmdtDesc, item.cmdtyId)} id="stAccCol2Menu">{item.cmdtDesc}</MenuItem>
                        );
                        })
                        }
                    </DropdownButton>
                    </div>
                    */}
                  {col2 === "FC" ? (
                    <div
                      className={`${styles.qtyfilter2} SOAqtydropdown`}
                      id="qtyfiltercol2"
                    >
                      <DropdownButton
                        title={i18next.t(unit_code2)}
                        id="bg-nested-dropdown"
                        className="reportsDropdown btnText"
                      >
                        {currency2 &&
                          currency2.map((currencyval) => {
                            return (
                              <MenuItem
                                onClick={() => this.currency2(currencyval)}
                                id="stAccCurrencyVal"
                              >
                                {currencyval}
                              </MenuItem>
                            );
                          })}
                      </DropdownButton>
                    </div>
                  ) : null}
                  {column2 && cmdty_metal.indexOf(column2) !== -1 ? (
                    <div
                      className={`${styles.qtyfilter2} SOAqtydropdown`}
                      id="qtyfiltercol2"
                    >
                      <DropdownButton
                        title={unit_code2}
                        id="bg-nested-dropdown"
                        className="reportsDropdown btnText"
                      >
                        {qty2 &&
                          qty2.map((unitMeasure) => {
                            return (
                              <MenuItem
                                onClick={() => this.qty2(unitMeasure)}
                                id="stAccMeasure"
                              >
                                {unitMeasure}
                              </MenuItem>
                            );
                          })}
                      </DropdownButton>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className={styles.soaExportOptions}>
              <div className={`${styles.exportfileBaracc} exportfileBaracc`}>
                <div className={`${styles.accfilterItem} accfilterItem`}>
                  <button
                    type="button"
                    className={
                      this.state.isRefreshDisabled === true
                        ? `${styles.disabled} ${styles.goBtn}`
                        : `${styles.goBtn}`
                    }
                    id="SOAgobtn"
                    onClick={() => this.handlestatementReport()}
                  >
                    {this.props.refreshIcon}
                  </button>
                </div>
                <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                  {this.props.statement_AccountData.length !== 0 && (
                    <span>
                      <ExcelFile
                        filename="StatementOfAccountReport"
                        element={<img src="/images/xls.png" />}
                      >
                        {headercol2 && headercol2 === "None" ? (
                          <ExcelSheet
                            dataSet={multiDataSet}
                            name="StatementOfAccountReport"
                          />
                        ) : (
                          <ExcelSheet
                            dataSet={multiDataSet2}
                            name="StatementOfAccountReport"
                          />
                        )}
                      </ExcelFile>
                    </span>
                  )}
                  {this.props.statement_AccountData.length === 0 && (
                    <img src="/images/xls.png" onClick={this.changeFlag} />
                  )}
                  <span>
                    <img
                      src="/images/pdf.png"
                      onClick={() => {
                        this.generatePdf("PDF");
                      }}
                    />
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${styles.statementOfAccountbl} statementOfAccountbl`}
          id="statementOfAccountbl"
        >
          {this.state.loadtableflag === true ? (
            <div className={styles.rptoverlay}>
              <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          ) : null}
          {headercol2 && headercol2 === "None" ? (
            <div
              className={`${styles.statementOfAccounttable1} reportsTblGrid`}
            >
              <Grid
                rows={this.state.statement_AccountData}
                columns={statement_AccountDatacols1}
              >
                {this.state.reportsRowsCount > 10 ? (
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                ) : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState
                  value={this.state.searchValue}
                  onValueChange={this.onChangeSearchValue}
                />
                <IntegratedFiltering />
                <Table
                  tableComponent={withStyles(rowStyle, {
                    name: "TableComponent",
                  })(TableComponentBase)}
                  columnAutoWidth={true}
                  messages={NoDataMsg}
                  noDataCellComponent={NoDataCell}
                  cellComponent={TableCell}
                />
                <TableHeaderRow />
                {this.state.reportsRowsCount > 10 &&
                this.props.selectedCssColor !== "DR" ? (
                  <PagingPanel
                    pageSizes={this.state.pageSizes}
                    messages={pagingPanelMessages}
                    containerComponent={PagingContainer}
                  />
                ) : this.state.reportsRowsCount > 10 &&
                  this.props.selectedCssColor === "DR" ? (
                  <PagingPanel
                    pageSizes={this.state.pageSizes}
                    messages={pagingPanelMessages}
                    containerComponent={PagingContainerdark}
                  />
                ) : null}
                <TableBandHeader columnBands={columnBands1} />
                <Toolbar />
                <SearchPanel
                  messages={searchPlaceholderMsg}
                  autoComplete="new-password"
                />
              </Grid>
            </div>
          ) : (
            <div
              className={`${styles.statementOfAccounttable2} reportsTblGrid`}
            >
              <Grid
                rows={this.state.statement_AccountData}
                columns={statement_AccountDatacols2}
              >
                {this.state.reportsRowsCount > 10 &&
                this.props.selectedCssColor !== "DR" ? (
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                ) : this.state.reportsRowsCount > 10 &&
                  this.props.selectedCssColor === "DR" ? (
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                ) : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState
                  value={this.state.searchValue}
                  onValueChange={this.onChangeSearchValue}
                />
                <IntegratedFiltering />
                <Table
                  tableComponent={withStyles(rowStyle, {
                    name: "TableComponent",
                  })(TableComponentBase)}
                  columnAutoWidth={true}
                  messages={NoDataMsg}
                  noDataCellComponent={NoDataCell}
                  cellComponent={TableCell}
                />
                <TableHeaderRow />
                {this.state.reportsRowsCount > 10 &&
                this.props.selectedCssColor !== "DR" ? (
                  <PagingPanel
                    pageSizes={this.state.pageSizes}
                    messages={pagingPanelMessages}
                    containerComponent={PagingContainer}
                  />
                ) : this.state.reportsRowsCount > 10 &&
                  this.props.selectedCssColor === "DR" ? (
                  <PagingPanel
                    pageSizes={this.state.pageSizes}
                    messages={pagingPanelMessages}
                    containerComponent={PagingContainerdark}
                  />
                ) : null}
                <TableBandHeader columnBands={columnBands2} />
                <Toolbar />
                <SearchPanel
                  messages={searchPlaceholderMsg}
                  autoComplete="new-password"
                />
              </Grid>
            </div>
          )}
        </div>
      </div>
    );
  }
}
